import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/pec-uz.uz/www/frontend/layouts/default.vue").then(m => m.default || m))
}